<template lang="pug">
  .gw-popup(v-if="isProjectRegShowed" :class="getPopupClass")
    .gw-popup__content
      button.gw-popup__close(@click="close" v-if="!gcMode")
      section.gw-form
        .gw-form__heading(v-if="showHeading")
          a.gw-form__logo(:class="platform", :href="platform_data[platform]")

        .gw-form__content
          h3.gw-form__title(v-html="$t('mygames.title')")

          .gw-form__agreement-block
            .gw-form__block
              .gw-form__checkbox.gw-checkbox(v-if="canUserSubscribe")
                input#gw-mail-agreement.gw-checkbox__input(type="checkbox", v-model="subscription")
                label.gw-checkbox__label(for="gw-mail-agreement")
                  span.gw-form__agreement.gw-form__agreement_lg(v-html="$t('mygames.email_agreement')")
              .gw-form__checkbox.gw-checkbox(v-if="!isAutoAcceptTerms")
                input#gw-terms-agreement.gw-checkbox__input(type="checkbox", v-model="agree")
                label.gw-checkbox__label(for="gw-terms-agreement")
                  span.gw-form__agreement.gw-form__agreement_lg(v-html="$t('mygames.terms_agreement', {links: buildLinksList})")
              .gw-form__checkbox.gw-checkbox(v-if="isConfirmAges")
                input#gw-terms-ages.gw-checkbox__input(type="checkbox", v-model="ages")
                label.gw-checkbox__label(for="gw-terms-ages")
                  span.gw-form__agreement.gw-form__agreement_lg(v-html="$t('mygames.ages_agreement')")

          .gw-form__error(v-if="error")
            Error.gw-form__error-text(:isIconShown="false" :code="error.code")
            button.gw-form__btn.gw-btn(@click="errorButtonHandler" v-html="$t('mygames.error.button')" )

          .gw-form__submit(v-else)
            button.gw-form__btn.gw-btn(@click="userRegister" :disabled="isDisabled") {{$t("mygames.button")}}


</template>
<script>
import { mapGetters } from "vuex";
import TermsLinksMixin from "../../../mixins/terms/TermsLinksMixin";
import Error from "../../errors/NewError";
import env from "../../../libs/tools/Environment";
import UrlParams from "../../../libs/tools/UrlParams";
export default {
  components: { Error },
  mixins: [TermsLinksMixin],

  props: {
    showHeading: {
      type: Boolean,
      default: true,
    },
    platform: {
      type: String,
      default: "mygames",
    },
    gcMode: {
      type: Boolean,
      default: false,
    },
    noRedirect: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      subscription: false,
      agree: false,
      ages: false,
      is_pending: false,
      error: false,
      platform_data: {
        mygames: "https://my.games/",
        vkplay: "https://vkplay.ru/",
      },
    };
  },

  computed: {
    ...mapGetters("global", ["isUserProcessed", "isUserAuthedNotRegistered", "isRegShow"]),
    getRegConfig() {
      return this.$authService.config.getConfig().project_reg;
    },
    canUserSubscribe() {
      const email_validation = /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/i;

      return (
        this.isUserProcessed &&
        !this.isSubscribeDisabled &&
        email_validation.test(String(this.$authService.getUserEmail()).toLowerCase())
      );
    },
    isDisabled() {
      let terms_accepted = this.isAutoAcceptTerms || this.agree;
      let ages_accepted = !this.isConfirmAges || this.ages;

      return !terms_accepted || !ages_accepted || this.is_pending;
    },
    isSubscribeDisabled() {
      return this.getRegConfig.is_subscribe_disabled;
    },
    isAutoAcceptTerms() {
      return this.getRegConfig.is_auto_accept_terms;
    },
    isConfirmAges() {
      return this.getRegConfig.is_confirm_ages;
    },
    /**
     * auto reg is enabled only if a project supports it (by config) and user can't see any checkboxes (no subscribe, no terms accept).
     * Also, auto reg can be enbled in gc mode.
     * @returns {boolean}
     */
    isAutoRegEnabled() {
      return !!(
        this.getRegConfig.is_auto_reg_enabled &&
        !this.canUserSubscribe &&
        this.isAutoAcceptTerms
      );
    },
    isProjectRegShowed() {
      return this.error || (this.isRegShow && !this.isAutoRegEnabled);
    },
    getPopupClass() {
      return {
        "gw-popup--mode_gc": this.gcMode,
      };
    },
  },
  watch: {
    isUserProcessed: {
      handler: function(is_processed) {
        if (is_processed && this.isAutoRegEnabled && this.isUserAuthedNotRegistered) {
          this.userRegister();
        }
      },
      immediate: true,
    },
  },

  created() {
    const request_needed = this.getRegConfig.terms && (env.isPromoPage() || this.gcMode);
    if (request_needed) {
      if (this.$nuxt) {
        this.getTermsInfo(true);
      } else {
        document.addEventListener("init_vue_components", () => {
          this.getTermsInfo(true);
        });
      }
    }
  },

  methods: {
    userRegister() {
      this.is_pending = true;
      let gc_redirect_link = false;
      if (this.gcMode && !this.noRedirect) {
        // See this task if you need any additional details https://jira.my.games/browse/GODWEB-71701
        const gc_id = UrlParams.get("gc_id") || window.__GEMS.gc_id;
        gc_redirect_link = `${env.getHomePage()}?mailrugames=registered%2F${gc_id}`;
      }
      this.$authService.userRegister(gc_redirect_link, this.subscription).then(result => {
        if (!result.status) {
          this.is_pending = false;
          this.error = result.error;
        }
      });
    },
    errorButtonHandler() {
      if (this.error && this.error.code === 2105) {
        this.$authService.showSignin();
      } else {
        window.location.reload();
      }
    },
    close() {
      this.is_pending = false;
      this.$store.commit("global/hideReg");
      this.closeGc();
    },
    closeGc() {
      if (this.gcMode && typeof gc_close_window !== "undefined") {
        setTimeout(function() {
          window.gc_close_window();
        }, 200);
      }
    },
  },
};
</script>

<style lang="css" scoped src="../../../styles/gw-popup.css"></style>
